var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"newsbox b-b-1 line-color-shallow",on:{"click":_vm.runpage}},[_c('div',{staticClass:"imgbox"},[_c('img',{attrs:{"src":_vm.item.imgurl,"alt":""}})]),_c('div',{staticClass:"piotitle"},[_vm._v(" "+_vm._s(_vm.item.title)+" ")]),_c('div',{staticClass:"pl15 pt15 pb20"},[_vm._v(_vm._s(_vm.item.date))])])
}
var staticRenderFns = []

export { render, staticRenderFns }